import Vue from 'vue';
import {daoInjection} from "./dao";

Vue.use(daoInjection);
